import {
  getagents,
  getagentsByChildrenUser,
  getagentsByUser,
} from "../../js/api/getAgents.js";
import { _t } from "../../services/TranslationService.js";

let MyBetsUsersAgent = {
  render: async () => {
    let role = localStorage.getItem("role");

    let agents = await getagents();
    let agentsView = "";
    console.log(agents);

    let userCoins = [];
    let userCoinsView = ``;

    if (localStorage.getItem("coins")) {
      userCoins = JSON.parse(localStorage.getItem("coins"));

      userCoins.forEach((coin) => {
        userCoinsView += `<option value="${coin.id}">${coin.currency}</option>`;
      });
    }

    if (agents && agents.children_users.length !== 0) {
      const allIds = agents.children_users.map(a => a.id);
      const uniqueIds = [...new Set(allIds)];
      uniqueIds.forEach((agentId) => {
        const agent = agents.children_users.find(a => a.id === agentId);
        agentsView =
          agentsView + `<option value="${agent.id}">${agent.username}</option>`;
      });
    }

    if (role == "User") window.location.href = "/";

    let view = /*html*/ `<div class="myBetsWrapper m-t-6">
             <div class="myBetsHeader">
               <a class="backBtn">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"/></svg>
               </a>
               <span>${_t('Baste e mia')}</span>
             </div>
             <div class="myBetsFilter">
               <span>${_t('Filtro me date')}:</span>
               <input type="text" readonly  class="form-control" id="myCalendar">
             </div>
             <div class="myBetsAdministrationFilter ${
               role !== "User" ? "makeFullWidth" : ""
             }" >
             
                <select name="" id="myBetsUsersUserCoinSelect">
                  ${userCoinsView}
                </select>
                <select name="agentSelect" id="agentSelect">
                    <option value="">${_t('Zgjidh nje perdorues')}:</option>
                    ${agentsView}
                </select>
             </div>
             <div class="myBetsTable m-t-6" id="myAgents">

             </div>
             <div class="myBetsFooter m-t-6">
               <span>${_t('All')}</span>
               <span></span>
               <span id="totalBetsValue"></span>
             </div>
           </div>
     `;
    return view;
  },
  after_render: async () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    let months = [
      "Janar",
      "Shkurt",
      "Mars",
      "Prill",
      "Maj",
      "Qershor",
      "Korrik",
      "Gusht",
      "Shtator",
      "Tetor",
      "Nentor",
      "Dhjetor",
    ];
    let currentMonthDescription = `${months[today.getMonth()]}`;

    let ranges = {
      Sot: [moment(), moment()],
      Dje: [moment().subtract(1, "days"), moment().subtract(1, "days")],
      2020: [moment().subtract(1, "year"), moment()],
      2021: [moment("01 Jan 2021"), moment()],
    };

    ranges[`${currentMonthDescription}`] = [
      moment().startOf("month"),
      moment().endOf("month"),
    ];
    ranges[`${months[today.getMonth() == 0 ? 11 : today.getMonth() - 1]}`] = [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ];

    today = yyyy + "-" + mm + "-" + dd;

    let agents = await getagentsByUser(
      today,
      today,
      $("#myBetsUsersUserCoinSelect").val()
    );

    renderAgents(agents);

    let totalBet = 0;
    $("body .wonCoefItem").each(function () {
      totalBet += parseFloat(
        $(this).text().substring($(this).text().length, -1)
      );
    });

    let betsStartDate = today;
    let betsEndDate = today;
    saveMetaData(betsStartDate, betsEndDate);
    //$('body #totalBetsValue').text(totalBet);
    $("#myCalendar").daterangepicker(
      {
        ranges: ranges,
        alwaysShowCalendars: true,
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
        opens: "center",
      },
      async function (start, end, label) {
        $("#contentLoader").append(
          '<div class="loaderWrapper">\n' +
            '            <div class="loader"></div>\n' +
            "        </div>"
        );
        console.log(
          "New date range selected: " +
            start.format("YYYY-MM-DD") +
            " to " +
            end.format("YYYY-MM-DD") +
            " (predefined range: " +
            label +
            ")"
        );
        let startDate = start.format("YYYY-MM-DD");
        let endDate = end.format("YYYY-MM-DD");

        betsStartDate = startDate;
        betsEndDate = endDate;
        agents = await getagentsByUser(
          startDate,
          endDate,
          $("#myBetsUsersUserCoinSelect").val()
        );

        renderAgents(agents);
        saveMetaData(betsStartDate, betsEndDate);

        //$('body #totalBetsValue').text(totalBet);
        $("body .loaderWrapper").remove();
      }
    );

    $("body").on("change", "#myBetsUsersUserCoinSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      let agents = [];
      if ($("#agentSelect").val())
        agents = await getagentsByChildrenUser(
          betsStartDate,
          betsEndDate,
          $("#agentSelect").val(),
          $("#myBetsUsersUserCoinSelect").val()
        );
      else
        agents = await getagentsByUser(
          betsStartDate,
          betsEndDate,
          $("#myBetsUsersUserCoinSelect").val()
        );
      renderAgents(agents);
      saveMetaData(betsStartDate, betsEndDate);
    });

    $("body").on("change", "#agentSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      let agents = [];
      if ($(e.currentTarget).val())
        agents = await getagentsByChildrenUser(
          betsStartDate,
          betsEndDate,
          $(e.currentTarget).val(),
          $("#myBetsUsersUserCoinSelect").val()
        );
      else
        agents = await getagentsByUser(
          betsStartDate,
          betsEndDate,
          $("#myBetsUsersUserCoinSelect").val()
        );
      renderAgents(agents);
      saveMetaData(betsStartDate, betsEndDate);
    });
  },
};

function saveMetaData(betsStartDate, betsEndDate) {
  localStorage.setItem("currencySelected", $("#myBetsUsersUserCoinSelect").val());
  localStorage.setItem("betsStartDate", betsStartDate);
  localStorage.setItem("betsEndDate", betsEndDate);
}

function renderAgents(agents) {
  if (agents) {
    let agentsView = ``;
    let total = 0;
    agents.forEach((agent) => {
      agentsView += ` <a href="#/mybetsuserdetails/${
        agent.parent_id
      }" class="mybetsusersrow">
          <span>${agent.agent} (${agent.bets})</span>
          <span>${parseFloat(agent.return).toFixed(2)} </span>
      </a>`;
      total += parseFloat(agent.return);
    });

    document.getElementById("myAgents").innerHTML = agentsView;

    $("#totalBetsValue").text(total.toFixed(2));
  }
}

export default MyBetsUsersAgent;
